import React from 'react';
import { Moon, Sun } from 'lucide-react';

export const ThemeToggle = ({ isDark, onToggle }) => {
  return (
    <button
      onClick={() => onToggle(!isDark)}
      className={`relative w-16 h-8 rounded-full transition-all duration-300 flex items-center px-1 border ${
        isDark 
          ? 'bg-gradient-to-r from-indigo-800 to-slate-900 border-indigo-500/40 justify-end shadow-[0_0_12px_rgba(99,102,241,0.3)]' 
          : 'bg-gradient-to-r from-amber-300 to-yellow-400 border-amber-500/50 justify-start shadow-[0_0_12px_rgba(245,158,11,0.4)]'
      }`}
      aria-label="Toggle theme"
    >
      <div className={`w-6 h-6 rounded-full shadow-lg transform transition-transform duration-300 flex items-center justify-center ${
        isDark 
          ? 'bg-indigo-950 text-yellow-300 shadow-indigo-500/30' 
          : 'bg-white text-amber-600 shadow-amber-400/40'
      }`}>
        {isDark ? <Moon size={14} /> : <Sun size={14} />}
      </div>
      
      {/* Decorative dots */}
      {isDark ? (
        <>
          <div className="absolute left-2 w-1 h-1 bg-yellow-300/40 rounded-full animate-pulse"></div>
          <div className="absolute left-4 w-1.5 h-1.5 bg-indigo-400/30 rounded-full"></div>
        </>
      ) : (
        <>
          <div className="absolute right-2 w-1 h-1 bg-orange-600/30 rounded-full"></div>
          <div className="absolute right-4 w-1.5 h-1.5 bg-yellow-600/20 rounded-full"></div>
        </>
      )}
    </button>
  );
};